import React, { useEffect, useRef } from "react";

import { UseAuth } from "src/auth/AuthContext";
import APIService from "src/services/Api";
import { convertirFechaAUsuario } from "src/helpers/mixins";


const LastConnection: React.FC = ({ }) => {
  const isMounted = useRef(true); // Para evitar llamadas a setState en componentes desmontados
  const { user, isAuthenticated } = UseAuth()
  useEffect(() => {
    const updateLastConnection = async () => {
      if (!isMounted.current) return; // Evita llamadas si el componente se desmontó
      try {
        const now  =convertirFechaAUsuario(new Date()) // Obtiene la hora actual en UTC ISO 8601
        if(isAuthenticated && user && user?.id){
          await APIService.updateLastConnection({ userId: user?.id, lastConnection: now });
        }
      } catch (error) {
        //console.error("Error al actualizar la última conexión:", error);
      }
    };

    updateLastConnection(); // Actualiza la primera vez al montar el componente

    const intervalId = setInterval(updateLastConnection, 60000); // Actualiza cada minuto (60000 ms)

    return () => {
      isMounted.current = false; // Marca el componente como desmontado
      clearInterval(intervalId); // Limpia el intervalo al desmontar el componente
    };
  }, [user]);

  return null; // Este componente no renderiza nada visualmente
};

export default LastConnection;
